export default __webpack_public_path__ + "static/media/558.0d2c84a0.png";